<template>
  <div>
    <a-spin :spinning="loading">
      <div class="row">
        <div class="col-6">
          <p class="text-dark font-weight-bold mb-2">SMS Settings</p>
        </div>
        <div class="col-6 text-right">
          <p class="font-weight-bold mb-2">Balance:
            <span class="text-danger ml-1">{{ smsBalance }}</span>
          </p>
        </div>
      </div>
      <hr>
      <a-form class="mb-4" :form="form">
        <div class="row">
          <div class="col-12 col-md-4">
            <a-form-item label="Amount">
              <a-input-number
                style="width:100%"
                :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                :min="1"
                v-decorator="['amount', {rules: [{ required: true, message: 'Please input an amount' }], initialValue: undefined}]"
                @change="updateCreditValue"
              />
            </a-form-item>
          </div>
          <div class="col-12 col-md-4">
            <a-form-item label="SMS Credits">
              <a-input-number
                style="width:100%"
                :min="1"
                v-decorator="['credit', {rules: [{ required: true, message: 'Please input a credit' }], initialValue: undefined}]"
              />
            </a-form-item>
          </div>
          <div class="col-12 col-md-4 mt-md-4 pt-1">
              <input type="submit" value="submit" class="d-none"/>
              <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">
                Add SMS Credit
              </a-button>
          </div>
        </div>
      </a-form>

      <hr>
      <SmsTransactionsTable :schoolId="schoolId" :reload="reload" type="superadmin"/>
    </a-spin>
  </div>
</template>

<script>
import SmsTransactionsTable from '@/components/school/Manage/SMS/Transactions/index.vue'
export default {
  name: 'SmsSettings',
  mounted: function() {
    this.getSmsBalance()
  },
  props: ['reload'],
  components: {
    SmsTransactionsTable,
  },
  computed: {
    schoolId: function () {
      return this.$route.params.id
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      smsBalance: 0,
      loading: false,
    }
  },
  methods: {
    updateCreditValue(value) {
      const credit = value * 3
      this.form.setFieldsValue({ credit: credit })
    },
    getSmsBalance() {
      this.$http.get('/api/school/sms/balance/' + this.schoolId)
        .then(({ data }) => {
          this.smsBalance = data.data.balance
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to add SMS Credits!`,
            onOk: () => {
              this.$http
                .post('/api/school/sms/recharge/' + this.schoolId, {
                  amount: values.amount,
                  credit: values.credit,
                })
                .then(({ data }) => {
                  this.$eventBus.$emit('smsRecharged')
                  this.loading = false
                  this.$notification['success']({
                    message: 'SMS Credit added!',
                    description: 'SMS Credits has be added successfully',
                  })
                  this.form.resetFields()
                  this.getSmsBalance()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
  },
}
</script>
